import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import React, { useEffect } from 'react';
import { ColorValue, StyleSheet, View } from 'react-native';
import { Skeleton } from 'react-native-skeletons';

interface Props {
  backgroundColor: ColorValue;
  height: number;
  progressBarColor: ColorValue;
  progressPercentage: number;
}

export const AnimatedSkeletonProgress: React.FC<Props> = ({
  backgroundColor,
  height,
  progressBarColor,
  progressPercentage,
}) => {
  const animatedWidth = useSharedValue(0);

  useEffect(() => {
    animatedWidth.value = withTiming(progressPercentage, {
      duration: 300,
    });
  }, [animatedWidth, progressPercentage]);

  const animatedStyle = useAnimatedStyle(() => ({
    width: `${animatedWidth.value}%`,
  }));

  return (
    <View style={styles.container}>
      <Skeleton
        borderRadius={0}
        color={backgroundColor as string}
        height={height}
      />
      <Animated.View style={[styles.progressBar, animatedStyle]}>
        <View style={{ backgroundColor: progressBarColor, height }} />
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
  progressBar: {
    position: 'absolute',
  },
});
